module.exports = __webpack_public_path__ + "media/images/icon-item-daad0164d800f6c778575beec69b5902.svg";